<template>
  <div class="page-title">
    <div class="row align-items-center py-4">

      <!-- Page Header -->
      <div class="col-lg-6 col-7">
        <div class="bg-gradient-primary rounded page-header">
          <h6 class="h2 d-inline-block mb-0">
            <i v-if="icon" :class="icon"></i>
            {{ main }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <ol class="breadcrumb breadcrumb-dark breadcrumb-links">
              <li class="breadcrumb-item">
                <span>{{ sub }}</span>
                <a v-if="help"><i @click="helpModal = true" class="fas fa-question-circle fa-lg text-white ml-2" style="cursor: pointer;"></i></a>
              </li>
              <modal :show.sync="helpModal" class="col-12 ml-5">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">{{ titleHelp }}</h5>
                </template>
                <p class="pre-formatted">{{ content }}</p>
              </modal>
            </ol>
          </nav>
        </div>
      </div>

      <!-- Page Actions -->
      <div class="col-lg-6 col-5 text-right">
        <slot name="actions">
          <!-- <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>-->
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    icon: {
      type: String,
      required: false,
    },
    main: {
      type: String,
      required: false,
    },
    sub: {
      type: String,
      required: false,
    },
    // Hel props
     help: {
      type: Boolean,
      required: false,
    },
    titleHelp: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      helpModal: false,
    }
  },
};
</script>

<style>
.page-title h1 {
  margin: 0px;
}

.page-title h2 {
  color: #777;
  margin-top: 5px;
  font-size: 1rem;
}

.page-title .breadcrumb-item a {
  color: #32325d;
}

.page-header {
  width: max-content;
  width: -moz-max-content;
  padding: 5px 10px;
}

.pre-formatted {
  white-space: pre-wrap; /* 👈 this is the important part */
  padding: 1rem;
  border-left: 3px solid #ccc!important;
  border-color: #2196F3!important;
}
</style>
